import { render } from "./app-alert.vue?vue&type=template&id=c01a0f44"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/alert/app-alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c01a0f44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c01a0f44', __exports__)) {
    console.log('reload')
    api.reload('c01a0f44', __exports__)
  }
  
  module.hot.accept("./app-alert.vue?vue&type=template&id=c01a0f44", () => {
    console.log('re-render')
    api.rerender('c01a0f44', render)
  })

}


export default __exports__